import React from 'react';
import { Link } from 'gatsby';
import Image from '../images/icon.png';
import { FaGithub, FaInstagram, FaTwitter, FaDiscord, FaGlobe } from 'react-icons/fa';

const Topbar = (props) => {
  return(
  <div className='TopbarStyle'>
    <Link to='/' title='GatsbyFinds'><img src={ Image } alt='G' />atsbyFinds</Link>
    <div className='right'>
      <a href='https://github.com/gatsbyjs/gatsby' title='Fork GatsbyJS on GitHub' target='_blank' rel='noopener noreferrer'><FaGithub className='ico' /></a>
      <a href='https://instagram.com/gatsbyjs' title='Follow GatsbyJS on Instagram' target='_blank' rel='noopener noreferrer'><FaInstagram className='ico' /></a>
      <a href='https://twitter.com/gatsbyjs' title='Follow GatsbyJS on Twitter' target='_blank' rel='noopener noreferrer'><FaTwitter className='ico' /></a>
      <a href='https://gatsby.dev/discord' title='Chat With GatsbyJS us on Discord' target='_blank' rel='noopener noreferrer'><FaDiscord className='ico' /></a>
      <a href='https://www.gatsbyjs.org' title='Go to GatsbyJS' target='_blank' rel='noopener noreferrer'><FaGlobe className='ico' /></a>
      { props.Menu }
    </div>
  </div>
  );
}
export default Topbar;